import Marquee from "react-fast-marquee";
import { SUBJECTS } from "@/lib/site";

export const Ribbon = () => (
  <section className="py-6 bg-primary text-primary-foreground overflow-hidden border-y border-white/10">
    <Marquee speed={40} gradient={false} autoFill data-testid="subjects-marquee">
      {SUBJECTS.map((s, i) => (
        <div key={i} className="flex items-center gap-6 mx-6">
          <span className="font-heading font-bold text-2xl md:text-3xl tracking-tight">{s}</span>
          <span className="text-accent text-2xl">✳</span>
        </div>
      ))}
    </Marquee>
  </section>
);

export default Ribbon;
